import {useEffect, useState} from 'react'
import { getAbout } from '../../HTTP/user';
import Log from "../../media/videoFont.png"

export const About = () => {
  const [about, setAbout] = useState(null); // string html
  
    useEffect(() => {
      const fetchAbout = async () => {
        try {
          const res = await getAbout();
          if (res) {
            setAbout(res.value);
          }
        }  catch (error) {
          console.error("Erreur lors de la récupération des CGU :", error);
        }
      }
      fetchAbout();
    }, []);
  
    return (
      <div className='py-12 px-4 sm:px-6 lg:px-8 md:max-h-screen md:overflow-y-auto text-white' style={{ backgroundImage: `url(${Log})`, backgroundSize: 'cover', backgroundPosition: 'center' }}>
        <div dangerouslySetInnerHTML={{ __html: about }}></div>
      </div>
    )
}